import { ElementRef, Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';
import { DeckHttpClient } from 'schema';
import { translations } from '../../../i18n/translations';
import { errors as translatedErrors } from '../../shared/helpers/errors';

declare const UIkit: any;

export function createParams(_params: any): HttpParams {
  const { ...params } = _params;
  for (const propName in params) {
    if (params[propName] === null || params[propName] === undefined || params[propName] === '') {
      delete params[propName];
    }
  }

  return new HttpParams({ fromObject: params });
}

const commonErrorsKeys = ['details', 'detail', 'error', 'errors', 'date', 'non_field_errors'];

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  activeElement: Element;
  baseUrl = environment.baseUrl;
  language = document.location.pathname.includes('/en/') ? 'en' : 'no';

  constructor(private http: DeckHttpClient) {}

  createParams = createParams;

  deleteModal(modal: ElementRef): void {
    modal.nativeElement.remove();
  }

  getUserPNR(id: string): Observable<{ pnr: string }> {
    return this.http.usersIdfyPnrCreate({ id });
  }

  retrievePEPData(id: string, view: string) {
    return this.http.patch<null>(`${this.baseUrl}${view}/${id}/aml-check`, null);
  }

  retrievePEPChecks(id: string, view: string) {
    return this.http.post<null>(`${this.baseUrl}bankid/pep-check`, null);
  }

  scrollToTop(): void {
    document.body.classList.add('prevent-scroll');
    const height = document.documentElement.scrollTop || document.body.scrollTop;
    if (height > 0) {
      window.requestAnimationFrame(this.scrollToTop.bind(this));
      window.scrollTo(0, height - height / 6);
    } else {
      document.body.classList.remove('prevent-scroll');
    }
  }

  showError(text: string): void {
    UIkit.notification(
      `
      <div class='uk-text-center' style='padding: 0 15px'>
        ${text}
      </div>
    `,
      { status: 'danger', pos: 'bottom-center' }
    );
  }

  _showNestedErrors(prefix: string[], errorMessage: any) {
    let handled = false;
    if (typeof errorMessage == 'string') errorMessage = [errorMessage];
    if (Array.isArray(errorMessage)) {
      if (!errorMessage.length) return false;
      if (commonErrorsKeys.includes(prefix[prefix.length - 1])) prefix.pop();
      const prefixStr = prefix.length ? prefix.join('.') + ': ' : '';
      const translatedMessages = errorMessage
        .map((msg) => {
          if (typeof msg.msg == 'string') msg = msg.msg;
          return translations[this.language][msg] || (translatedErrors[msg] && translatedErrors[msg][this.language]) || msg;
        })
        .join('\n');
      this.showError(prefixStr + translatedMessages);
      return true;
    } else {
      Object.entries(errorMessage).forEach(([key, val]) => {
        handled = handled || this._showNestedErrors([...prefix, key], val);
      });
      return handled;
    }
  }

  showErrors(errors: Record<string, string | string[] | { msg: string }[]>) {
    let handled = this._showNestedErrors([], errors);
    if (!handled) {
      this.showError(translations[this.language].defaultError);
    }
  }

  showNotification(text: string): void {
    UIkit.notification(
      `
      <div class='uk-text-center' style='padding: 0 15px'>
        ${text}
      </div>
    `,
      { pos: 'bottom-center' }
    );
  }
}
